<template>
  <v-dialog v-model="dialogProxy" max-width="640">
    <v-card class="dialog-card" elevation="0">
      <v-card-title class="dialog-title d-flex justify-space-between align-center">
        <div class="d-flex align-center">
          <v-icon class="mr-2" color="#F4811F">
            mdi-truck-delivery-outline
          </v-icon>
          <span class="dialog-title-text">
            {{ isEdit ? "แก้ไขบริษัทขนส่ง" : "เพิ่มบริษัทขนส่ง" }}
          </span>
        </div>

        <v-btn icon small @click="dialogProxy = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider />

      <v-card-text class="dialog-body">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col cols="12" md="6">
              <div class="label-text mb-1">
                ชื่อบริษัทขนส่ง <span class="red--text">*</span>
              </div>
              <v-text-field v-model="localItem.name" dense outlined hide-details="auto"
                :rules="[v => !!(v || '').trim() || 'กรุณากรอกชื่อบริษัทขนส่ง']" />
            </v-col>

            <v-col cols="12" md="6">
              <div class="label-text mb-1">
                ประเภทการส่ง (Ship Master) <span class="red--text">*</span>
              </div>
              <v-select
                v-model="localItem.shipId"
                :items="ships"
                item-text="shipName"
                item-value="id"
                dense
                outlined
                hide-details="auto"
                :rules="[v => !!v || 'กรุณาเลือกประเภทการส่ง']"
                placeholder="เลือกประเภทการส่ง"
              />
            </v-col>

            <!-- <v-col cols="12" md="6">
              <div class="label-text mb-1">
                รหัสบริษัท (CODE)
              </div>
              <v-text-field
                v-model="localItem.code"
                dense
                outlined
                hide-details="auto"
                placeholder="เช่น FLASH, J&T"
              />
            </v-col> -->

            <!-- <v-col cols="12" md="6">
              <div class="label-text mb-1">
                ชื่อผู้ติดต่อ
              </div>
              <v-text-field
                v-model="localItem.contactName"
                dense
                outlined
                hide-details="auto"
              />
            </v-col> -->

            <!-- <v-col cols="12" md="6">
              <div class="label-text mb-1">
                เบอร์โทรศัพท์
              </div>
              <v-text-field
                v-model="localItem.phone"
                dense
                outlined
                hide-details="auto"
              />
            </v-col> -->

            <v-col cols="12">
              <div class="label-text mb-1">
                URL สำหรับติดตามพัสดุ
              </div>
              <v-text-field v-model="localItem.link" dense outlined hide-details="auto"
                placeholder="เช่น https://tracking.example.com?code={trackingNumber}" />
              <div class="helper-text">
                ใช้ <code>{trackingNumber}</code> แทนตำแหน่งที่ต้องการให้แทนด้วยเลขพัสดุ
              </div>
            </v-col>

            <v-col cols="12" md="6">
              <div class="label-text mb-1">
                สถานะการใช้งาน
              </div>
              <v-select v-model="localItem.status" :items="statusItems" item-text="text" item-value="value" dense
                outlined hide-details="auto" />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider />

      <v-card-actions class="pa-4">
        <v-spacer />
        <v-btn color="#F3F4F6" class="cancel-btn mr-2" elevation="0" @click="dialogProxy = false">
          <span style="color: #374151">ยกเลิก</span>
        </v-btn>
        <v-btn color="#F4811F" class="confirm-btn" elevation="0" :loading="loading" @click="handleSave">
          <span style="color: white">{{ isEdit ? "บันทึกการแก้ไข" : "บันทึก" }}</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { getShipsApi } from "@/services/api/adminServices";
export default {
  name: "AdminVehicleTypeDialog",

  props: {
    value: { type: Boolean, default: false },
    item: { type: Object, default: null },
    loading: { type: Boolean, default: false },
  },

  data() {
    return {
      localItem: {
        id: null,
        name: "",
        shipId: null,
        link: "",
        status: "active",
      },
      ships: [],
      valid: false,
      statusItems: [
        { text: "เปิดใช้งาน", value: "active" },
        { text: "ปิดใช้งาน", value: "inactive" },
      ],
    };
  },

  computed: {
    dialogProxy: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      },
    },

    isEdit() {
      return !!(this.localItem && this.localItem.id);
    },
  },

  watch: {
    item: {
      handler(val) {
        if (val) {
          this.localItem = {
            id: val.id || val._id || null,
            name: val.name || "",
            shipId: val.shipId || null,
            link: val.link || "",
            status: val.status || "active",
          };
        } else {
          this.resetForm();
        }
      },
      immediate: true,
    },

    dialogProxy(val) {
      if (!val) {
        this.resetForm();
      }
    },
  },

  methods: {
    resetForm() {
      this.localItem = {
        id: null,
        name: "",
        shipId: null,
        link: "",
        status: "active",
      };
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },

    handleSave() {
      if (!this.$refs.form) {
        this.$emit("save", { ...this.localItem });
        return;
      }

      const isValid = this.$refs.form.validate();
      if (!isValid) return;

      this.$emit("save", { ...this.localItem });
    },

    async loadShips() {
      try {
        const res = await getShipsApi();
        this.ships = res.data || [];
      } catch (err) {
        console.error("loadShips error:", err);
      }
    },
  },

  async created() {
    await this.loadShips();
  },
};
</script>

<style scoped>
.dialog-card {
  border-radius: 16px !important;
  box-shadow: none !important;
}

.dialog-title {
  padding: 20px 24px 16px !important;
}

.dialog-body {
  padding: 20px 24px 24px !important;
}

.dialog-title-text {
  font-size: 18px;
  font-weight: 600;
  color: #1f2a39;
}

.label-text {
  font-size: 14px;
  font-weight: 400;
  color: #6b717f;
}

.helper-text {
  font-size: 12px;
  color: #9ca3af;
  margin-top: 4px;
}

.cancel-btn {
  border-radius: 10px !important;
  text-transform: none !important;
  font-weight: 500 !important;
}

.confirm-btn {
  border-radius: 10px !important;
  text-transform: none !important;
  font-weight: 500 !important;
}
</style>
